import React from 'react'
import { Box, Typography, IconButton, CircularProgress } from '@mui/material'
import { ArrowLeft } from 'lucide-react'
import { useGetListeningTopicsQuery } from 'graphql/generated/graphql'
import TopicColumn from './TopicColumn'

interface AllTopicsFeedsProps {
  onBack: () => void
}

/**
 * Multi-topic feeds view: shows one vertical column per active listening topic side-by-side.
 */
export default function AllTopicsFeeds({ onBack }: AllTopicsFeedsProps): JSX.Element {
  const { data, loading } = useGetListeningTopicsQuery()
  const topics = (data?.getListeningTopics ?? []).filter((t) => t.isActive)

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <IconButton onClick={onBack} sx={{ color: 'rgba(255,255,255,0.7)' }}>
          <ArrowLeft size={20} />
        </IconButton>
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', flex: 1 }}>
          All Signals
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress sx={{ color: '#a855f7' }} />
        </Box>
      ) : topics.length === 0 ? (
        <Typography sx={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', py: 8 }}>
          No active signals yet.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', pb: 2 }}>
          {topics.map((topic) => (
            <TopicColumn key={topic.id} topicId={topic.id} topicName={topic.name} />
          ))}
        </Box>
      )}
    </Box>
  )
}
